<template>
  <div></div>
</template>


<script>
export default {
  name: "modificationManuscript",
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/view/contributor/modificationManuscript.vue